// utils/request.js
import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'  // 如果用的是 element-plus 就改成 import { ElMessage } from 'element-plus'

// 创建 axios 实例
const service = axios.create({
   baseURL: process.env.VUE_APP_EDIT, // 基础路径
    //baseURL: 'http://localhost:8080', // 基础路径
    timeout: 10000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(
    config => {
        // 如果是 OSS 上传，不加 token
        if (!config.url.startsWith('https://dake-designer.oss-cn-beijing.aliyuncs.com')) {
            const token = localStorage.getItem('token')
            if (token) {
                config.headers['token'] = token
            }
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 如果是 OSS 上传，直接返回原始响应
        if (response.config.url.startsWith('https://dake-designer.oss-cn-beijing.aliyuncs.com')) {
            return response
        }
        const res = response.data
        console.log("res",res)
        if (res.code === 401) {
            Message.error(res.msg || '请登录')
            localStorage.removeItem('token')
            router.push('/login')
            return Promise.resolve(res)
        } else if (res.code === 500) {
            return res
        } else if (res.code === 402) {
            return res
        } else if (res.code !== 200) {
            Message.error(res.message || '请求失败')
            // 改成 resolve，不抛出异常
            return Promise.resolve(res)
        }

        return res
    },
    error => {
        // 网络错误时 error.response 可能是 undefined
        Message.error(error.response?.data?.message || '网络错误')

        // 这里不要 reject，防止抛到控制台变成未捕获错误
        return Promise.resolve({ code: -1, message: '网络错误' })
    }
)

export default service
